import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a8437c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "base-search__icon",
  width: "32",
  height: "32",
  viewBox: "0 0 24 24",
  "aria-hidden": "false"
}, [
  /*#__PURE__*/_createElementVNode("desc", { lang: "en-US" }, "An X shape"),
  /*#__PURE__*/_createElementVNode("path", { d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "base-search__submit primary-btn",
  "aria-label": "Search",
  type: "submit"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "base-search__icon",
    width: "32",
    height: "32",
    viewBox: "0 0 24 24",
    "aria-hidden": "false"
  }, [
    /*#__PURE__*/_createElementVNode("desc", { lang: "en-US" }, "A magnifying glass"),
    /*#__PURE__*/_createElementVNode("path", { d: "M16.5 15c.9-1.2 1.5-2.8 1.5-4.5C18 6.4 14.6 3 10.5 3S3 6.4 3 10.5 6.4 18 10.5 18c1.7 0 3.2-.5 4.5-1.5l4.6 4.5 1.4-1.5-4.5-4.5zm-6 1c-3 0-5.5-2.5-5.5-5.5S7.5 5 10.5 5 16 7.5 16 10.5 13.5 16 10.5 16z" })
  ])
], -1))

import { ref, watch } from 'vue';

export type Props = {
  placeholder?: string,
  modelValue?: string,
}
export type Emits = {
  (e: 'update:modelValue', keyValue: Props['modelValue']): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSearch',
  props: {
    placeholder: { default: 'Type in a value' },
    modelValue: { default: '' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;




const inputValue = ref<string>(props.modelValue);
const fieldEl = ref<HTMLInputElement | null>(null);

const onSearch = () => {
  emit('update:modelValue', inputValue.value);
};
const onClear = () => {
  fieldEl.value?.focus(); // eslint-disable-line no-unused-expressions
  inputValue.value = '';
};

watch(() => props.modelValue, (currValue) => {
  inputValue.value = currValue;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "base-search primary-border",
    role: "search",
    onSubmit: _withModifiers(onSearch, ["prevent"])
  }, [
    _withDirectives(_createElementVNode("input", {
      ref_key: "fieldEl",
      ref: fieldEl,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      class: "base-search__input field",
      type: "search",
      autocapitalize: "none",
      autocomplete: "off",
      spellcheck: "false",
      placeholder: _ctx.placeholder
    }, null, 8, _hoisted_2), [
      [
        _vModelText,
        inputValue.value,
        void 0,
        { trim: true }
      ]
    ]),
    (inputValue.value.length)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "base-search__reset transparent-btn",
          "aria-label": "Clear",
          type: "reset",
          onClick: onClear
        }, _hoisted_4))
      : _createCommentVNode("", true),
    _hoisted_5
  ], 40, _hoisted_1))
}
}

})